<template>
  <div
    v-if="
      offline || connectionCheckRunning || tasksDeferred.length || alerts.length
    "
  >
    <div id="offlineBadge">
      <div :class="{ badge: true, obscure: connectionCheckRunning }">
        <img
          src="~smartdoors-shared/img/icons/warning-important.svg"
          width="24"
        />
      </div>
      <spinner v-if="connectionCheckRunning" size="1x"></spinner>
    </div>

    <popover
      class="connectivity-alerts"
      target="#offlineBadge"
      type="plain"
      :offset="[0, 10]"
      position="left-end"
      arrow="important"
      :close-btn="false"
    >
      <div class="d-flex flex-column align-items-end">
        <div
          v-for="(alert, index) in alertsSorted"
          :key="index"
          :class="`alert alert-${alert.type} mb-xs`"
        >
          <span v-if="alert.key">{{
            __(`connectivity.alerts.keys.${alert.key}.${alert.type}`)
          }}</span>
          <span v-else-if="typeof alert.message === 'string'">{{
            alert.message
          }}</span>

          <button
            v-if="
              alert.data &&
              alert.data.view &&
              alert.data.view != $store.state.navigation.currentRoute.name
            "
            @click="
              removeAlert(index);
              $router.push({ name: alert.data.view });
            "
            class="btn btn-secondary btn-xsmall btn-auto-width ml-xs mr-xs"
          >
            {{ __("connectivity.buttons.alert_details") }}
          </button>

          <button @click="removeAlert(index)">
            <img src="~smartdoors-shared/img/icons/cross.svg" />
          </button>
        </div>

        <div
          :class="{
            alert: true,
            'alert-warning': offline || connectionCheckRunning,
            'alert-success': !offline && !connectionCheckRunning,
          }"
        >
          <span v-if="connectionCheckRunning">{{
            __("connectivity.alerts.checking")
          }}</span>
          <span v-else-if="offline">{{
            __("main.common.alerts.offline")
          }}</span>
          <span v-else>{{ __("main.common.alerts.back_online") }}</span>

          <span v-if="offline && tasksDeferred.length">{{
            __("main.common.alerts.tasks_deferred", tasksDeferred.length)
          }}</span>
          <span v-else-if="tasksDeferred.length">{{
            __("main.common.alerts.tasks_running", tasksDeferred.length)
          }}</span>
        </div>
      </div>
    </popover>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  props: {
    connectionCheckRunning: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    alerts() {
      return this.$store.getters["alerts/connectivity"];
    },
    tasksDeferred() {
      return this.$store.state.tasks.stack;
    },
    alertsSorted() {
      let alertsSort = this.alerts.reverse();
      alertsSort = this.removeSameAlert(alertsSort);
      return alertsSort;
    },
    ...mapState(["offline"]),
  },
  methods: {
    removeAlert(index) {
      this.$store.dispatch("alerts/remove", { connectivity: index });
    },
    removeSameAlert(item) {
      const uniqueItem = [];
      for (let i = 0; i < item.length; i++) {
        if (!this.checkIfContain(uniqueItem, item[i].key)) {
          uniqueItem.push(item[i]);
        }
      }
      this.$store.dispatch("alerts/removeDuplicate", uniqueItem);
      return uniqueItem;
    },
    checkIfContain(item, value) {
      let res = false;
      for (let i = 0; i < item.length; i++) {
        if (item[i].key == value) {
          res = true;
        }
      }
      return res;
    },
  },
};
</script>

<style lang="scss">
.popover.connectivity-alerts {
  .popover__container {
    transform: translateY(-5px);
  }
}
</style>